import { SVGProps, Ref, forwardRef } from 'react';

export const SmartphoneOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path d="M6 2.8v1.4h4V2.8z" fill="currentColor" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.5 5.333C2.5.667 3.188 0 8 0s5.5.667 5.5 5.333v5.334C13.5 15.333 12.813 16 8 16s-5.5-.667-5.5-5.333zm1.4 0c0-1.155.045-1.957.157-2.535.109-.56.257-.773.363-.876.111-.108.345-.259.942-.368C5.97 1.444 6.807 1.4 8 1.4s2.03.043 2.638.154c.597.11.83.26.942.368.107.103.254.315.363.876.112.578.157 1.38.157 2.535v5.334c0 1.155-.045 1.957-.157 2.535-.109.56-.256.773-.363.876-.111.108-.345.259-.942.368-.608.11-1.445.154-2.638.154s-2.03-.043-2.638-.154c-.597-.11-.831-.26-.942-.368-.106-.103-.254-.315-.363-.876-.112-.578-.157-1.38-.157-2.535z"
                fill="currentColor"
            />
        </g>
    </svg>
));
SmartphoneOutlinedSize16Glyph.displayName = 'SmartphoneOutlinedSize16Glyph';
